// import { ethers } from "ethers";
// import BasicGreenProject from "../Abi/BasicGreenProject.json";
// import BasicInfrastructure from "../Abi/BasicInfrastructure.json";
// import GovernanceGreenProject from "../Abi/GovernanceGreenProject.json";
// import GovernanceInfrastructure from "../Abi/GovernanceInfrastructureChange.json";
// import GovernanceCarbonMonitoring from "../Abi/GovernanceCarbonMonitoring.json";
// import GreenProjectNFT from "../Abi/GreenProjectNFT.json";
// import InfrastructureChangeNFT from "../Abi/InfrastructureChangeNFT.json";
// import CloseCarbonToken from "../Abi/CloseCarbonToken.json";
// import DonationCertificate from "../Abi/DonationCertificate.json";
// import EnergySharingContract from "../Abi/EnergySharingContract.json";
// import CloseCarbonEnergyEfficiency from "../Abi/CloseCarbonEnergyEfficiency.json";

// import dotenv from "dotenv";
// import {  NETWORKS } from "./config";
// // import EnergyTradingRouter from "../Abi/NewEnergyRouterABI.json";
// dotenv.config();
// const testChainID = 11155420;
// const chainID = 10;
// // const chainID = 137;
// // const chainID = 11155111;
// const network = NETWORKS[chainID];
// const testNetwork = NETWORKS[testChainID];



// async function getContracts() {
//   if (!REACT_APP_PRIVATE_KEY) {
//     throw new Error("DEPLOYER_PRIVATE_KEY is undefined");
//   }
//   if (!REACT_APP_BUYER_PRIVATE_KEY) {
//     throw new Error("BUYER_PRIVATE_KEY is undefined");
//   }
//   if (!REACT_APP_SELLER_PRIVATE_KEY) {
//     throw new Error("SELLER_PRIVATE_KEY is undefined");
//   }
//   // Get signer
//   const deployer = new ethers.Wallet(REACT_APP_PRIVATE_KEY);
//   const provider = new ethers.JsonRpcProvider(REACT_APP_MUMBAI_URL);
//   const testProvider = new ethers.JsonRpcProvider(REACT_APP_MUMBAI_URL);
//   const sellerAddress = new ethers.Wallet(REACT_APP_SELLER_PRIVATE_KEY);
//   const buyerAddress = new ethers.Wallet(REACT_APP_BUYER_PRIVATE_KEY);
//   // const provider = deployer.connect(provider);
//   const signer = deployer.connect(provider);
//   const testSigner = deployer.connect(testProvider);
//   const seller1 = sellerAddress.connect(testProvider);
//   const buyer1 = buyerAddress.connect(testProvider);
//   // const userSigner = new ethers.Wallet(privateKey, provider);

//   // Get contract instances
//   const basicGreenContractInstance = new ethers.Contract(
//     network.BASIC_GREEN_PROJECT,
//     BasicGreenProject.abi,
//     signer
//   );
//   const basicInfrastructureContractInstance = new ethers.Contract(
//     network.BASIC_INFRASTRUCTURE_CHANGE,
//     BasicInfrastructure.abi,
//     signer
//   );
//   const governanceGreenContractInstance = new ethers.Contract(
//     network.GOVERNANCE_GREEN_PROJECT,
//     GovernanceGreenProject.abi,
//     signer
//   );
//   const governanceinfrastructureContractInstance = new ethers.Contract(
//     network.GOVERNANCE_INFRASTRUCTURE_CHANGE,
//     GovernanceInfrastructure.abi,
//     signer
//   );
//   const governanceCarbonMonitoringInstance = new ethers.Contract(
//     network.GOVERNANCE_CARBON_MONITORING,
//     GovernanceCarbonMonitoring.abi,
//     signer
//   );
//   const greenProjectNFTContractInstance = new ethers.Contract(
//     network.GREEN_PROJECT_NFT,
//     GreenProjectNFT.abi,
//     signer
//   );
//   const infrastructureChangeNFTContractInstance = new ethers.Contract(
//     network.INFRASTRUCTURE_CHANGE_NFT,
//     InfrastructureChangeNFT.abi,
//     signer
//   );
//   const closeCarbonTokenContractInstance = new ethers.Contract(
//     network.CLOSE_CARBON_TOKEN,
//     CloseCarbonToken.abi,
//     signer
//   );
//   const donationCertificateContractInstance = new ethers.Contract(
//     network.DONATION_CERTIFICATE,
//     DonationCertificate.abi,
//     signer
//   );
//   const energySharingContractInstance = new ethers.Contract(
//     testNetwork.ENERGY_TRADING_CONTRACT_ADDRESS,
//     EnergySharingContract.abi,
//     testSigner
//   );
//   const closeCarbonEnergyEfficiencyContractInstance = new ethers.Contract(
//     testNetwork.CLOSE_CARBON_ENERGY_EFFICIENCY, // Add this to NETWORKS config
//     CloseCarbonEnergyEfficiency.abi,
//     signer
//   );

//   return {
//     signer,
//     basicGreenContractInstance,
//     basicInfrastructureContractInstance,
//     governanceGreenContractInstance,
//     governanceinfrastructureContractInstance,
//     governanceCarbonMonitoringInstance,
//     greenProjectNFTContractInstance,
//     infrastructureChangeNFTContractInstance,
//     closeCarbonTokenContractInstance,
//     donationCertificateContractInstance,
//     energySharingContractInstance,
//     seller1,
//     buyer1,
//     testSigner,
//     closeCarbonEnergyEfficiencyContractInstance,
//     // energyEfficiencyRouterInstance,

//   };
// }

// export { getContracts };

import { ethers } from "ethers";
import BasicGreenProject from "../Abi/BasicGreenProject.json";
import BasicInfrastructure from "../Abi/BasicInfrastructure.json";
import BusinessGreen from "../Abi/BusinessGreen.json";
import BusinessInfrastructureChange from "../Abi/BusinessInfrastructureChange.json";
import BusinessCarbonMonitoring from "../Abi/BusinessCarbonMonitoring.json";
import GovernanceGreenProject from "../Abi/GovernanceGreenProject.json";
import GovernanceInfrastructure from "../Abi/GovernanceInfrastructureChange.json";
import GovernanceCarbonMonitoring from "../Abi/GovernanceCarbonMonitoring.json";
import GreenProjectNFT from "../Abi/GreenProjectNFT.json";
import InfrastructureChangeNFT from "../Abi/InfrastructureChangeNFT.json";
import CloseCarbonToken from "../Abi/CloseCarbonToken.json";
import DonationCertificate from "../Abi/DonationCertificate.json";
import EnergySharingContract from "../Abi/EnergySharingContract.json";
import CloseCarbonEnergyEfficiency from "../Abi/CloseCarbonEnergyEfficiency.json";

import dotenv from "dotenv";
import { NETWORKS } from "./config";

dotenv.config();

const testChainID = 11155420;
const chainID = 10;
const network = NETWORKS[chainID];
const testNetwork = NETWORKS[testChainID];

// Environment variables
const REACT_APP_PRIVATE_KEY = process.env.REACT_APP_PRIVATE_KEY
const REACT_APP_BUYER_PRIVATE_KEY = process.env.REACT_APP_BUYER_PRIVATE_KEY
const REACT_APP_SELLER_PRIVATE_KEY = process.env.REACT_APP_SELLER_PRIVATE_KEY

// Network URLs from environment variables
const REACT_APP_OPTIMISM_MAINNET_URL = process.env.REACT_APP_MUMBAI_URL
const REACT_APP_OPTIMISM_SEPOLIA_URL = process.env.REACT_APP_OPTIMISM_TESTNET_URL

// Select the appropriate URL based on network
const getNetworkUrl = (chainId: number) => {
  switch (chainId) {
    case 10: // Optimism Mainnet
      return REACT_APP_OPTIMISM_MAINNET_URL;
    case 11155420: // Optimism Sepolia testnet
      return REACT_APP_OPTIMISM_SEPOLIA_URL;
    // default:
    // return REACT_APP_OPTIMISM_MAINNET_URL; // Default fallback
  }
};

async function getContracts() {
  if (!REACT_APP_PRIVATE_KEY) {
    throw new Error("REACT_APP_PRIVATE_KEY is undefined");
  }
  if (!REACT_APP_BUYER_PRIVATE_KEY) {
    throw new Error("REACT_APP_BUYER_PRIVATE_KEY is undefined");
  }
  if (!REACT_APP_SELLER_PRIVATE_KEY) {
    throw new Error("REACT_APP_SELLER_PRIVATE_KEY is undefined");
  }

  // Get network URLs
  const mainNetworkUrl = getNetworkUrl(chainID);
  const testNetworkUrl = getNetworkUrl(testChainID);

  if (!mainNetworkUrl || !testNetworkUrl) {
    throw new Error("Network URL is undefined. Please check your environment variables.");
  }

  // Get signer
  const deployer = new ethers.Wallet(REACT_APP_PRIVATE_KEY);
  const provider = new ethers.JsonRpcProvider(mainNetworkUrl);
  const testProvider = new ethers.JsonRpcProvider(testNetworkUrl);
  const sellerAddress = new ethers.Wallet(REACT_APP_SELLER_PRIVATE_KEY);
  const buyerAddress = new ethers.Wallet(REACT_APP_BUYER_PRIVATE_KEY);

  const signer = deployer.connect(provider);
  const testSigner = deployer.connect(testProvider);
  const seller1 = sellerAddress.connect(testProvider);
  const buyer1 = buyerAddress.connect(testProvider);

  // Get contract instances
  const basicGreenContractInstance = new ethers.Contract(
    network.BASIC_GREEN_PROJECT,
    BasicGreenProject.abi,
    signer
  );
  const basicInfrastructureContractInstance = new ethers.Contract(
    network.BASIC_INFRASTRUCTURE_CHANGE,
    BasicInfrastructure.abi,
    signer
  );
  const governanceGreenContractInstance = new ethers.Contract(
    network.GOVERNANCE_GREEN_PROJECT,
    GovernanceGreenProject.abi,
    signer
  );
  const governanceinfrastructureContractInstance = new ethers.Contract(
    network.GOVERNANCE_INFRASTRUCTURE_CHANGE,
    GovernanceInfrastructure.abi,
    signer
  );
  const governanceCarbonMonitoringInstance = new ethers.Contract(
    network.GOVERNANCE_CARBON_MONITORING,
    GovernanceCarbonMonitoring.abi,
    signer
  );
  const greenProjectNFTContractInstance = new ethers.Contract(
    network.GREEN_PROJECT_NFT,
    GreenProjectNFT.abi,
    signer
  );
  const infrastructureChangeNFTContractInstance = new ethers.Contract(
    network.INFRASTRUCTURE_CHANGE_NFT,
    InfrastructureChangeNFT.abi,
    signer
  );
  const closeCarbonTokenContractInstance = new ethers.Contract(
    network.CLOSE_CARBON_TOKEN,
    CloseCarbonToken.abi,
    signer
  );
  const donationCertificateContractInstance = new ethers.Contract(
    network.DONATION_CERTIFICATE,
    DonationCertificate.abi,
    signer
  );
  const energySharingContractInstance = new ethers.Contract(
    testNetwork.ENERGY_TRADING_CONTRACT_ADDRESS,
    EnergySharingContract.abi,
    testSigner
  );
  const closeCarbonEnergyEfficiencyContractInstance = new ethers.Contract(
    testNetwork.CLOSE_CARBON_ENERGY_EFFICIENCY,
    CloseCarbonEnergyEfficiency.abi,
    signer
  );
  const businessGreenContractInstance = new ethers.Contract(
    testNetwork.BUSINESS_GREEN,
    BusinessGreen.abi,
    testSigner

  );
  const businessInfrastructureContractInstance = new ethers.Contract(
    testNetwork.BUSINESS_INFRASTRUCTURE_CHANGE,
    BusinessInfrastructureChange.abi,
    testSigner

  );
  const businessCarbonMonitoringContractInstance = new ethers.Contract(
    testNetwork.BUSINESS_CARBON_MONITORING,
    BusinessCarbonMonitoring.abi,
    testSigner

  );

  return {
    signer,
    basicGreenContractInstance,
    basicInfrastructureContractInstance,
    governanceGreenContractInstance,
    governanceinfrastructureContractInstance,
    governanceCarbonMonitoringInstance,
    greenProjectNFTContractInstance,
    infrastructureChangeNFTContractInstance,
    closeCarbonTokenContractInstance,
    donationCertificateContractInstance,
    energySharingContractInstance,
    seller1,
    buyer1,
    testSigner,
    closeCarbonEnergyEfficiencyContractInstance,
    businessGreenContractInstance,
    businessInfrastructureContractInstance,
    businessCarbonMonitoringContractInstance,
  };
}

export { getContracts };